import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function avatarShow(
    game_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/game/avatar/${game_id}/show${queryString}`
    );
}

export async function avatarCreate(
    game_id: string,
    image_id: string
) {
    return await clientAxios.post(
        `admin/game/avatar/${game_id}/create`,
        { image_id }
    );
}

export async function avatarUpdate(
    game_id: string,
    image_id: string
) {
    return await clientAxios.put(
        `admin/game/avatar/${game_id}/update`,
        { image_id }
    );
}

export async function avatarDelete(
    game_id: string,
) {
    return await clientAxios.del(
        `admin/game/avatar/${game_id}/delete`,
    );
}
